import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ARROW_FOCUS_TRAP_ITEMS_CLASS_NAME = 'ArrowFocusTrapItems';

export const ARROW_FOCUS_TRAP_ITEMS_CLASS_SLOTS = ['root'] as const;

export type ArrowFocusTrapItemsClassSlot =
	(typeof ARROW_FOCUS_TRAP_ITEMS_CLASS_SLOTS)[number];

export interface ArrowFocusTrapItemsClasses {
	root: string;
	trapActive: string;
}

export type ArrowFocusTrapItemsClassKey = keyof ArrowFocusTrapItemsClasses;

export const getArrowFocusTrapItemsUtilityClass = (slot: string) =>
	generateUtilityClass(ARROW_FOCUS_TRAP_ITEMS_CLASS_NAME, slot);

export const arrowFocusTrapItemsClasses: ArrowFocusTrapItemsClasses =
	generateUtilityClasses(ARROW_FOCUS_TRAP_ITEMS_CLASS_NAME, [
		'root',
		'trapActive',
	]);

export default arrowFocusTrapItemsClasses;
